/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const DownloadTransmittalDocumentFile = zod.object({
  "fileId": zod.string().uuid().optional(),
  "id": zod.string().uuid().optional()
});

export type DownloadTransmittalDocumentFile = zod.input<typeof DownloadTransmittalDocumentFile>;
export type DownloadTransmittalDocumentFileOutput = zod.output<typeof DownloadTransmittalDocumentFile>;
